import { QueryClient } from '@tanstack/react-query';
import { fetchAddresses } from '~/api/address';
import { fetchIamUser } from '~/api/auth';
import { fetchUserConfiguration } from '~/api/user';
import { minutes5inMS } from '~/constants/times';
import { useSession } from '~/contexts/SessionContext';
import useAddress from '~/hooks/useAddress';
import useUserConfiguration from '~/hooks/useUserConfiguration';

export async function checkOnboarding(
  queryClient: QueryClient,
): Promise<'finished_onboarding' | undefined> {
  const userConfiguration = await queryClient.fetchQuery(
    ['user-configuration'],
    fetchUserConfiguration,
    {
      staleTime: minutes5inMS,
    },
  );

  if (
    userConfiguration?.properties?.list_count != null &&
    userConfiguration?.properties?.list_count > 0
  ) {
    return 'finished_onboarding';
  }

  const addresses = await queryClient.fetchQuery(['addresses'], fetchAddresses);
  const user = await fetchIamUser();

  const shipFromAddress = addresses?.find(a => a.flags.ship_from);

  if (shipFromAddress && user?.phone_number && user?.phone_verified) {
    return 'finished_onboarding';
  }

  return undefined;
}

export function useListFlowOnboarding(): 'finished_onboarding' | undefined {
  const { data: shipFromAddress } = useAddress('shipFrom');
  const { data: userConfiguration } = useUserConfiguration();
  const { user } = useSession();

  if (
    userConfiguration?.properties?.list_count != null &&
    userConfiguration?.properties?.list_count > 0
  ) {
    return 'finished_onboarding';
  }

  if (shipFromAddress && user?.phone_number && user?.phone_verified) {
    return 'finished_onboarding';
  }

  return undefined;
}
